import { createContext, useContext } from 'react';

type WidthValue = string | number | undefined;

interface PageSidebarContextValue {
  setEffectiveWidth: (width: WidthValue) => void;
  modeOverride?: 'floating-sidepanel';
}

export const PageSidebarContext = createContext<PageSidebarContextValue | null>(
  null,
);

export const usePageSidebarContext = () => useContext(PageSidebarContext);
